




























































import TinymceEditor from '@/components/TinymceEditor.vue'
import { Component, Vue } from 'vue-property-decorator'
import { findIotDeviceById, findIotDeviceByName, findAllIotDevice, createIotDevice, updateIotDevice, removeIotDevice } from '@/api/devices'
import { Message } from 'element-ui'
import axios from 'axios'

@Component({
  name: 'Devices',
  components: {
    TinymceEditor
  },
  filters: {
    parseTime: (timestamp: string) => {
      return new Date(Number(timestamp)).toLocaleString()
    }
  }
})
export default class extends Vue {
  private paging = {
    page: 1, // 当前所处分页
    limit: 10, // 页面条数
    total: 10 // 总数量
  }
  private activeName = 'first'
  private listLoading = true
  private searchValue = ''    // 搜索框value
  private handleType = 'add'  // add代表新增，edit代表编辑
  private deviceList = []  // 设备列表
  private deviceDialog: Boolean = false
  private deviceInfo = {   // 设备内容
    id: '',
    device_name: '',   
    device_status: '',
    utc_create: '',
    gmt_active: '', 
    gmt_online: '',
  }
  private FormRules = {
    device_name: [
      {required: true, message: '请输入设备名称', trigger: 'blur'}
    ]
  }


  created() {
    // 数据初始化
    this.init()
  }

  // 初始化界面
  private init() {
    this.getAllDevice()
  }
  
  // 设置当前所处分页
  private handleCurrentChange(val: number) {
    this.paging.page = val
    this.getAllDevice()

  }
  // 设置页面条数
  private handleSizeChange(val: number) {
    this.paging.limit = val
    this.getAllDevice()
  }

  // 新增设备
  private handleAdd() {
    this.resetForm()
    this.handleType = 'add'
    this.deviceDialog = true
  }
  // 编辑设备
  private handleEdit(index: number, row: any) {
    this.handleType = 'edti'
    this.deviceDialog = true; 
    row.type = String(row.type)
    this.deviceInfo = row 
  }
  // 确认表单
  private confirmForm() {
    (this.$refs.deviceInfo as any).validate((valid:boolean) => {
      if (valid) {
        this.handleType==='add' ? this.addDevice() : this.editDevice();
      } else {
        return false;
      }
    });
  }

  // 重置表单
  private resetForm() {
    this.$nextTick(() => {
      this.deviceInfo = {   // 设备内容
        id: '',
        device_name: '',   
        device_status: '',
        utc_create: '',
        gmt_active: '', 
        gmt_online: '',
      }
    })
  }

  // 删除设备
  private handleDelete(index: number, row: any) {
    this.$confirm('是否删除该设备?', '提示', { type: 'warning' })
      .then(() => {
        this.deviceInfo = row;
        this.deleteDeviceById()  // 删除设备
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });          
      });
  }

  // 刷新设备管理
  private freshOverviewDevice() {
    axios.get('https://api.karfans.cn/api/cms/manualSyncDevice?token=fc59fe3a5df696a1b644e4bec9c9b291').then(response => {
      if(response.data.code===200) this.getAllDevice('5')
      Message({ message: response.data.msg, type: 'success'})
    }).catch(error => {
      Message({ message: '请求失败', type: 'error' })
    })
  }


  private async addDevice() {
    const { data, code } = await createIotDevice(this.deviceInfo)
    if(code===200) {
      this.getAllDevice()
      this.deviceDialog = false
    }
  }
  private async editDevice() {
    const { data, code } = await updateIotDevice(this.deviceInfo)
    if(code===200) {
      this.getAllDevice()
      this.deviceDialog = false
    }
  }
  private async deleteDeviceById() {
    const { data, code } = await removeIotDevice({id: this.deviceInfo.id})
    if(code===200) {
      this.getAllDevice()
      this.deviceDialog = false
    }
  }

  private async getDeviceByTitle() {
    this.listLoading = true
    const { data } = await findIotDeviceByName({device_name: this.searchValue})
    this.deviceList = data
    this.paging.total = data.length // 更新分页数据
    setTimeout(() => { this.listLoading = false }, 0.5 * 1000)
  }
  private async getAllDevice(time:any='0.5') {
    this.listLoading = true
    const { data } = await findAllIotDevice(this.paging)
    this.deviceList = data.rows
    this.paging.total = data.count // 更新分页数据
    setTimeout(() => { this.listLoading = false }, time * 1000)
  }

}
